import logoSavio from "../../../../assets/images/logo_savio_b.svg";
import logoSavioDark from "../../../../assets/images/logo_savio_dark.svg";
import logoVandewieleDark from "../../../../assets/images/logo_vandewiele_dark.svg";
import logoVandewieleTurkDark from "../../../../assets/images/logo_vandewiele-turkey_dark.svg";
import logoVandewiele from "../../../../assets/images/logo_vandewiele_b.svg";
import logoVandewieleTurk from "../../../../assets/images/logo_vandewiele-turkey_b.svg";
import { LogoImg, Root, Environment } from "./AppLogo.styles";
import GoToPage from "../../../GoToPage/GoToPage";
import useBrands from "../../../../../explorer/hooks/useBrands";
import { FC } from "react";

const logoByBrand = (brand: string, useLightLogo: boolean) => {
    switch (brand) {
        case "savio":
            return useLightLogo ? logoSavio : logoSavioDark;
        case "vandewiele":
            return useLightLogo ? logoVandewiele : logoVandewieleDark;
        case "vandewieleturkey":
            return useLightLogo ? logoVandewieleTurk : logoVandewieleTurkDark;
        default:
            return logoVandewiele;
    }
};

type TAppLogo = {
    useLightLogo?: boolean;
};

const AppLogo: FC<TAppLogo> = (props) => {
    const { useLightLogo } = props;

    const development = process.env.NODE_ENV === "development" && true;
    const brand = useBrands().currentBrandUrl;
    return (
        <Root>
            <GoToPage page="home">
                <LogoImg src={logoByBrand(brand, useLightLogo ?? true)} alt="VDW" />
            </GoToPage>
            {development && <Environment />}
        </Root>
    );
};

export default AppLogo;
